export default {
  formTitle: 'Связаться с нами',
  submit: 'Отправить',
  mail: 'E-mail',
  name: 'Имя',
  comment: 'Сообщение',
  sendText: 'Спасибо за Ваше обращение!',
  toForm: 'Назад'
}


// WEBPACK FOOTER //
// ./src/locale/ru-RU/contactUs.js